import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactSession } from "react-client-session";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import "./Form.css";
import { getSuccessToast, getErrorToast } from "../../toast";
import { EXPIRY_ORDER_TYPE } from "../../constants";
import { Chip, Box, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const orderTypesArray = [
  { status: false, label: "ZRB  - Exp - BRK Return", value: "ZRB" },
  { status: false, label: "ZRE  - Sale Return", value: "ZRE" },
  { status: false, label: "ZRB2  - Exp - BRK Return", value: "ZRB2" },
  { status: false, label: "ZRE2  - Sale Return", value: "ZRE2" },
  { status: false, label: "ZRI  - Inst. Return Brk-Exp", value: "ZRI" },
  { status: false, label: "ZBI  - Inst. Saleable Return", value: "ZBI" },
  { status: false, label: "ZMD1 - RTN - Saleable Modern Trade", value: "ZMD1" },
  { status: false, label: "ZMD2 - RTN - BRK/EXP Modern Trade", value: "ZMD2" },
  // {status: false, label: 'ZPRB - Sale Return Prime Exp-Brk', value: 'ZPRB' },
  // {status: false, label: 'ZPRE - Sale Return Prime', value: 'ZPRE' },
  // {status: false, label: 'ZVT1 - Exp - brk Return Veticura', value: 'ZVT1' },
  // {status: false, label: 'ZVT2 - Saleable Return Veticura', value: 'ZVT2' }
];

const Form = () => {
  const navigate = useNavigate();

  const axiosPrivate = useAxiosPrivate();
  const [poNo, setPoNo] = useState("");
  const [partyName, setPartyName] = useState("");
  const [partyList, setPartyList] = useState([]);
  const [partyId, setPartyId] = useState();
  const partyNameRef = useRef("");
  const partyCodeRef = useRef();
  const cityRef = useRef();
  const [refNos, setrefNos] = useState([]);
  const [refInput, setRefInput] = useState("");
  const [refdate, setRefdate] = useState("None");
  const [transporterName, setTransporterName] = useState("None");
  const [lrNo, setLrNo] = useState("None");
  const [lrdate, setlrDate] = useState("None");
  const [caseNo, setCaseNo] = useState("None");
  const [receiveddate, setReceivedDate] = useState("");
  const [opendate, setOpenDate] = useState("None");
  const [disabled, setDisabled] = useState(false);
  // const username = ReactSession.get('username')
  // const allow_mt = !ALLOW_MT.includes(username)
  const [shipToParty, setShipToParty] = useState({
    current_party: [],
    value: null,
    required: false,
    disabled: true,
  });
  const [itParty, setITParty] = useState({
    current_party: [],
    value: null,
    required: false,
    disabled: true,
  });

  const [salesArea, setSalesArea] = useState({
    current_sales_area: [],
    value: null,
    required: false,
    disabled: true,
  });

  const [orderType, setOrderType] = useState({
    value: orderTypesArray[0],
  });

  const [otherParty, setOtherParty] = useState({
    disabled: true,
  });

  const displayDetailsHandler = (e) => {
    let currentValue;
    setPartyName(e.target.value);
    if (["", undefined, null, " "].includes(e.target.value)) {
      partyCodeRef.current.value = "";
      cityRef.current.value = "";
      setPartyId("");
    }
    axiosPrivate
      .get(`/data_entry/partymaster_searchbar/?search=${e.target.value}`)
      .then((res) => {
        setPartyList(res.data.results);
      });
    const selectedOption = Array.from(e.target.list.options).find(
      (option) => option.value === e.target.value,
    );
    if (selectedOption) {
      currentValue = JSON.parse(selectedOption.getAttribute("data-party"));
      setPartyName(currentValue.name);
      partyCodeRef.current.value = currentValue.customer;
      cityRef.current.value = currentValue.city;
      setPartyId(currentValue.party_master_id);
      if (!otherParty.disabled) {
        setShipToParty((prev) => ({
          ...prev,
          current_party: currentValue.shipparty_set,
          value: currentValue.shipparty_set[0]?.partner_number,
        }));
        setITParty((prev) => ({
          ...prev,
          current_party: currentValue.itpartner_set,
          value: currentValue.itpartner_set[0]?.partner_number,
        }));
        setSalesArea((prev) => ({
          ...prev,
          current_sales_area: currentValue.sales_area,
          value: currentValue.sales_area[0],
        }));
      }
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (!refNos.length) {
      getErrorToast("Please enter at least one reference number", 2000);
      return;
    }

    if (!partyId) {
      getErrorToast("Please select party name from the list", 2000);
    } else if (cityRef.current.value.length > 2) {
      const boxData = {
        po_number: poNo,
        order_type: orderType.value.value,
        ref_number: refNos,
        ref_date: refdate,
        lr_number: lrNo,
        lr_date: lrdate,
        received_date: receiveddate,
        open_date: opendate,
        case_number: caseNo,
        transporter_name: transporterName,
        party_master: partyId,
        sales_area: "01",
      };

      if (!otherParty.disabled) {
        Object.assign(boxData, {
          ship_party: parseInt(shipToParty.value),
          it_partner: parseInt(itParty.value),
          sales_area: salesArea.value,
        });
      }
      console.log(boxData);
      setDisabled(true);
      axiosPrivate
        .post("/data_entry/form_entry/", boxData)
        .then((res) => {
          if (res.data.length === 1) {
            let boxId = res.data[0].stockists_master_id;
            ReactSession.set("box_id", boxId);
            setPartyId(null);
            ReactSession.set("order_type", orderType.value.value);
            getSuccessToast("Claim added successfully", 2000);
            setTimeout(() => {
              navigate("/upload");
            }, 1000);
          } else {
            getSuccessToast("Claims added successfully", 2000);
            setTimeout(() => {
              navigate("/stockist-report");
            }, 1000);
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setDisabled(false);
        });
    } else {
      getErrorToast("Add all Fields", 1000);
      setDisabled(false);
    }
  };

  const partyClearHandler = (e) => {
    setPartyName("");
    setPartyList([]);
    setPartyId();
    setShipToParty({
      current_party: [],
      value: null,
      required: false,
      disabled: true,
    });
    setITParty({
      current_party: [],
      value: null,
      required: false,
      disabled: true,
    });
    setSalesArea({
      current_sales_area: [],
      value: null,
      required: false,
      disabled: true,
    });
    partyNameRef.current.value = "";
    cityRef.current.value = "";
    partyCodeRef.current.value = "";
  };

  const handelOrderType = (event) => {
    partyClearHandler();
    const currentValue = JSON.parse(event.target.value);
    const condiction = !EXPIRY_ORDER_TYPE.includes(currentValue?.value);
    setOrderType((pre) => ({ ...pre, value: currentValue }));
    setOtherParty((pre) => ({ ...pre, disabled: condiction ? false : true }));
  };

  const shipToPartyHandler = (event) => {
    let selected_ship_party = JSON.parse(event.target.value);
    setShipToParty((obj) => ({
      ...obj,
      value: selected_ship_party.partner_number,
    }));
  };

  const ITPartyHandler = (event) => {
    let selected_it_party = JSON.parse(event.target.value);
    setITParty((obj) => ({ ...obj, value: selected_it_party.partner_number }));
  };

  const SalseAreaHandler = (event) => {
    setSalesArea((obj) => ({ ...obj, value: event.target.value }));
  };

  return (
    <form onSubmit={submitHandler} className="home-form">
      <section className="c1 home-form-main-header">
        <h3>New Claim</h3>
      </section>

      <section className="home-form-section c2">
        <label htmlFor="po-no" className="home-form-header">
          Po No:
        </label>
        <input
          required={true}
          onChange={(e) => setPoNo(e.target.value)}
          className="home-form-input"
          type="text"
          id="po-no"
        />
      </section>

      <section className="home-form-section c2">
        <label htmlFor="po-no" className="home-form-header">
          Order Type:
        </label>
        <select
          name="order-type"
          id="order-type"
          onChange={handelOrderType}
          className="form__select"
        >
          {orderTypesArray.map((row) => (
            <option
              key={row.value}
              value={JSON.stringify(row)}
              disabled={row.status}
            >
              {row.label}
            </option>
          ))}
        </select>
      </section>

      <section className="home-form-section c4">
        <label htmlFor="party-name" className="home-form-header">
          Party Name:
        </label>
        <input
          required={true}
          list="party-name"
          onChange={displayDetailsHandler}
          onFocus={displayDetailsHandler}
          className="home-form-input home-form-input-lg"
          value={partyName}
          ref={partyNameRef}
        />
        <datalist id="party-name">
          {partyList &&
            partyList.map((party) => (
              <option
                key={party.party_master_id}
                data-party={JSON.stringify(party)}
                value={`${party.customer} | ${party.name}`}
              >
                {" "}
                {party.customer} | {party.name} | {party.city}
              </option>
            ))}
        </datalist>
      </section>

      <section className="home-form-section c4">
        <label htmlFor="party-code" className="home-form-header">
          Party Code:
        </label>
        <input
          required={true}
          ref={partyCodeRef}
          disabled={true}
          className="disabled home-form-input"
          type="number"
          id="party-code"
        />
      </section>

      <section className="home-form-section c5">
        <label className="home-form-header" htmlFor="city">
          City:
        </label>

        <input
          required={true}
          ref={cityRef}
          disabled={true}
          className="disabled home-form-input"
          type="text"
          id="city"
        />
      </section>

      <section className="home-form-section c4">
        <label htmlFor="ship-party-code" className="home-form-header">
          Ship To Party:
        </label>

        <select
          name="ship-party-code"
          onChange={shipToPartyHandler}
          id="ship-party-code"
          className="form__select"
          disabled={otherParty.disabled}
          required={false}
          key={shipToParty.select_party_id}
        >
          {shipToParty.current_party &&
            shipToParty.current_party.map((row, idx) => (
              <option key={idx} value={JSON.stringify(row)}>
                {row.partner_number} | {row.partner_name}
              </option>
            ))}
        </select>
      </section>

      <section className="home-form-section c4">
        <label htmlFor="it-party-code" className="home-form-header">
          IT Party:
        </label>

        <select
          name="it-party-code"
          onChange={ITPartyHandler}
          id="it-party-code"
          className="form__select"
          disabled={otherParty.disabled}
          required={false}
          key={itParty.select_party_id}
        >
          {itParty.current_party &&
            itParty?.current_party.map((row, idx) => (
              <option key={idx} value={JSON.stringify(row)}>
                {row.partner_number} | {row.partner_name}
              </option>
            ))}
        </select>
      </section>

      <section className="home-form-section c4">
        <label htmlFor="sales-area" className="home-form-header">
          Sales Area:
        </label>

        <select
          name="sales-area"
          onChange={SalseAreaHandler}
          id="sales-area"
          className="form__select"
          defaultValue={"01"}
          disabled={otherParty.disabled}
          required={!otherParty.disabled}
          key={itParty.select_party_id}
        >
          {salesArea.current_sales_area &&
            salesArea?.current_sales_area.map((row) => (
              <option key={row} value={row}>
                {row}
              </option>
            ))}
        </select>
      </section>

      {/* <section className="home-form-section c4">
        <label className="home-form-header" htmlFor="ref-no">
          REF No:
        </label>
        <input
          required={true}
          onChange={(e) => setrefNos(e.target.value)}
          className="home-form-input home-form-input-lg"
          type="text"
          id="ref-no"
        />
      </section> */}

      <section className="home-form-section c4">
        <label className="home-form-header" htmlFor="ref-no">
          REF No:
        </label>

        <Box
          className="home-form-input home-form-input-lg"
          style={{
            display: "flex",
            alignItems: "center",
            padding: "4px 8px",
            overflowX: "auto", // horizontal scroll only
            overflowY: "hidden", // hide vertical scroll
            whiteSpace: "nowrap",
            minHeight: "40px",
            width: "100%", // match parent width
            maxWidth: "400px",
            borderRadius: "4px",
            boxSizing: "border-box", // include padding in width
          }}
        >
          {Array.isArray(refNos) &&
            refNos.map((ref, index) => (
              <Chip
                key={index}
                label={ref}
                onDelete={() => setrefNos(refNos.filter((r) => r !== ref))}
                deleteIcon={<CloseIcon />}
                style={{ marginRight: "4px", flexShrink: 0 }}
              />
            ))}

          {Array.isArray(refNos) && refNos.length < 20 && (
            <TextField
              id="ref-no"
              placeholder="Enter REF No"
              value={refInput}
              onChange={(e) => setRefInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && refInput.trim() !== "") {
                  if (!refNos.includes(refInput.trim())) {
                    setrefNos([...refNos, refInput.trim()]);
                  }
                  setRefInput("");
                  e.preventDefault();
                }

                // 👇 Handle Backspace when input is empty
                if (
                  e.key === "Backspace" &&
                  refInput === "" &&
                  refNos.length > 0
                ) {
                  setrefNos(refNos.slice(0, -1)); // remove last ref
                  e.preventDefault();
                }
              }}
              onBlur={() => {
                if (
                  refInput.trim() !== "" &&
                  !refNos.includes(refInput.trim())
                ) {
                  setrefNos([...refNos, refInput.trim()]);
                }
                setRefInput("");
              }}
              variant="standard"
              InputProps={{ disableUnderline: true }}
              style={{
                minWidth: "100px",
                flexShrink: 0,
                fontSize: "16px",
                height: "100%",
              }}
            />
          )}
        </Box>

        {/* Counter below input */}
        <div
          style={{
            marginTop: "4px",
            fontSize: "12px",
            color: refNos.length >= 20 ? "red" : "#666",
            textAlign: "right",
          }}
        >
          {refNos.length} / 20
        </div>
      </section>

      <section className="home-form-section c7">
        <label className="home-form-header" htmlFor="ref-date">
          REF DATE:
        </label>
        <input
          required={true}
          onChange={(e) => setRefdate(e.target.value)}
          className="home-form-input  home-form-date-input-md"
          type="date"
          id="ref-date"
          min="1995-01-01"
          max={new Date().toISOString().split("T")[0]}
        />
      </section>

      <section className="home-form-section c8">
        <label className="home-form-header" htmlFor="lr-no">
          LR No:
        </label>
        <input
          required={true}
          onChange={(e) => setLrNo(e.target.value)}
          className="home-form-input"
          type="text"
          id="lr-no"
        />
      </section>

      <section className="home-form-section c9">
        <label className="home-form-header" htmlFor="lr-date">
          LR Date:
        </label>
        <input
          required={true}
          onChange={(e) => setlrDate(e.target.value)}
          className="home-form-input home-form-date-input-lg"
          type="date"
          name=""
          id="lr-date"
          min="1995-01-01"
          max={
            receiveddate === ""
              ? new Date().toISOString().split("T")[0]
              : receiveddate
          }
        />
      </section>

      <section className="home-form-section c10">
        <label className="home-form-header" htmlFor="received-date">
          Received Date:
        </label>
        <input
          required={true}
          onChange={(e) => setReceivedDate(e.target.value)}
          className="home-form-input home-form-date-input-lg"
          type="date"
          id="received-date"
          min="1995-01-01"
          max={new Date().toISOString().split("T")[0]}
        />
      </section>

      <section className="home-form-section c11">
        <label className="home-form-header" htmlFor="open-date">
          Open Date:
        </label>
        <input
          required={true}
          onChange={(e) => setOpenDate(e.target.value)}
          className="home-form-input home-form-date-input-md"
          type="date"
          id="open-date"
          min="1995-01-01"
          max={new Date().toISOString().split("T")[0]}
        />
      </section>

      <section className="home-form-section c12">
        {" "}
        <label className="home-form-header" htmlFor="case-no">
          Case No:
        </label>
        <input
          required={true}
          onChange={(e) => setCaseNo(e.target.value)}
          className="home-form-input"
          type="text"
          id="case-no"
        />
      </section>

      <section className="home-form-section c4">
        {" "}
        <label className="home-form-header" htmlFor="transporter-name">
          Transporter Name:
        </label>
        <input
          required={true}
          onChange={(e) => setTransporterName(e.target.value)}
          className="home-form-input home-form-input-lg"
          type="text"
          name=""
          id="transporter-name"
        />
      </section>

      <section className="home-form-submit-button-section c15">
        <button disabled={disabled} className="home-form-submit-button">
          Add new claim
        </button>
      </section>
    </form>
  );
};

export default Form;
export { orderTypesArray };
